import { ResponsiveBar } from '@nivo/bar';

import { theme } from '../../theme-dashboard';
import { NivoStackedBarChartData } from '../../types';
import { shortenNumber } from '../../utils';

export const StackedBarChart = ({
  data,
  keys,
  sortByKeyValue,
}: {
  data: NivoStackedBarChartData[];
  keys: (keyof NivoStackedBarChartData)[];
  sortByKeyValue?: keyof NivoStackedBarChartData;
}) => {
  const new_data = [...data].sort((a, b) => {
    if (sortByKeyValue !== undefined) {
      const lhs = a[sortByKeyValue];
      if (typeof lhs === 'string') {
        return lhs.localeCompare(b[sortByKeyValue] as string);
      }

      return lhs - (b[sortByKeyValue] as number);
    }
    return a['id'].localeCompare(b['id']);
  });

  return (
    <ResponsiveBar
      data={new_data}
      theme={theme}
      keys={keys as unknown as string[]}
      indexBy="id"
      margin={{ top: 32, right: 32, bottom: 32, left: 88 }}
      padding={0.25}
      innerPadding={1}
      layout="horizontal"
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      // colors={({ id }) => getColor(String(id))}
      colors={{ scheme: 'category10' }}
      borderRadius={4}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 0,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: 'middle',
        legendOffset: -40,
        truncateTickAt: 10,
      }}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={theme.textColor}
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'top-left',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: -24,
          itemsSpacing: 8,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 16,
          symbolShape: 'circle',
        },
      ]}
      tooltip={({ indexValue, value }) => {
        return (
          <div
            style={{
              padding: 8,
              background: theme.tooltip.container.background,
              fontSize: '12px',
            }}
          >
            {indexValue}: <strong>{shortenNumber(value, 2)}</strong>
          </div>
        );
      }}
    />
  );
};